export default function validation(response, messages, audits) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    return;
  }

  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('COMPANY_SHOULD_CONTAINS_TECHNIC_WORK_ORDER_PRODUCT') === 0) {
      messages.push({
        message: 'addEditAudit.messages.error.technicWorkOrdreProduct',
      });
    }
    if (message.indexOf('EXACTLY_ONE_PATRIMOINE_TYPE') === 0) {
      messages.push({
        message: 'addEditAudit.messages.error.onePatrimoine',
      });
    }
    if (message.indexOf('AUDITOR_MISSING') === 0) {
      messages.push({
        message: 'addEditAudit.messages.error.auditeurMissing',
      });
    }
    if (message.indexOf('AT_LEAST_ONE_PRODUCT') === 0) {
      messages.push({
        message: 'addEditAudit.messages.error.leastOneProduct',
      });
    }
    if (message.indexOf('COMPLETION_DATE_REQUIRED_TO_COMPLETE_TECHNIC_WORKING_ORDER') === 0) {
      if (!audits || !audits.length) {
        messages.push({
          message: 'addEditAudit.messages.error.auditNeedDateRealisation',
        });
      } else {
        const elements = message.split('|')[0].split('@');
        const ids = elements[1].replace('[', '').replace(']', '').split(',');
        const codes = [];
        ids.forEach((id) => {
          const auditFind = audits.find((audit) => { return audit.id === id; });
          if (auditFind) codes.push(auditFind.code);
        });
        if (codes.length > 0) {
          messages.push({
            message: ('addEditAudit.messages.error' + (codes.length > 1 ? '.auditNeedDateRealisationMulti' : '.auditNeedDateRealisation')),
            parametres: {
              code: codes.join(', '),
            },
          });
        } else {
          messages.push({
            message: 'addEditAudit.messages.error.auditNeedDateRealisation',
          });
        }
      }
    }
    if (message.indexOf('PLANNING_DATE_REQUIRED_TO_PLAN_TECHNIC_WORKING_ORDER') === 0) {
      if (!audits || !audits.length) {
        messages.push({
          message: 'addEditAudit.messages.error.auditNeedDatePlanif',
        });
      } else {
        const elements = message.split('|')[0].split('@');
        const ids = elements[1].replace('[', '').replace(']', '').split(',');
        const codes = [];
        ids.forEach((id) => {
          const auditFind = audits.find((audit) => { return audit.id === id; });
          if (auditFind) codes.push(auditFind.code);
        });
        if (codes.length > 0) {
          messages.push({
            message: ('addEditAudit.messages.error' + (codes.length > 1 ? '.auditNeedDatePlanifMulti' : '.auditNeedDatePlanif')),
            parametres: {
              code: codes.join(', '),
            },
          });
        } else {
          messages.push({
            message: 'addEditAudit.messages.error.auditNeedDatePlanif',
          });
        }
      }
    }
    if (message.indexOf('STATE_SHOULD_BE_ACHIEVE') === 0 || message.indexOf('STATE_SHOULD_BE_CLOSED') === 0) {
      const elements = message.split('|')[0].split('@');
      let errorMsg = '';
      switch (elements[0]) {
        case 'STATE_SHOULD_BE_ACHIEVE':
          errorMsg = 'auditShouldBeAchieve';
          break;
        case 'STATE_SHOULD_BE_CLOSED':
          errorMsg = 'auditShouldBeClosed';
          break;
        default:
          break;
      }
      if (!audits || !audits.length) {
        messages.push({
          message: `detailAudit.messages.error.${errorMsg}`,
        });
      } else {
        const ids = elements[1].replace('[', '').replace(']', '').split(',');
        ids.forEach(id => {
          const audit = audits.find(a => a.id === id);
          messages.push({
            message: `listeAudit.actionPopUp.errors.${errorMsg}`,
            parametres: { code: audit.code },
          });
        });
      }
    }
  });
}
